import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import SearchInput from '../common/SearchInput/SearchInput'
import DataTable from '../common/DataTable'
import OptionsMenu from '../common/OptionsMenu'
import DonwloadReportDialog from '../common/DonwloadReportDialog'
import Toaster from '../common/Toaster'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Avatar from '@material-ui/core/Avatar'
import QuotesIcon from '@material-ui/icons/AttachMoneyTwoTone'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import ArchiveDownloadIcon from '@material-ui/icons/Archive'

/** Language imports **/
import { Translate, getTranslate } from 'react-localize-redux'

/** Import section actions */
import {
	loadQuotesFromBackEnd,
	getQuotesCount,
	CHANGE_QUOTES_SORT_CRITERIA,
	CHANGE_QUOTES_QUERY,
	downloadQuotesInProcessSupplierReport,
	downloadReportByDateRangeReport,
	CHANGE_QUOTES_PAGINATION,
} from '../../store/quotes/QuotesActions'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import { showSuccessToaster, showErrorToaster } from './../../store/helpers/ToasterHelpers'

/**
 * Quotes view
 *
 * @class Quotes
 * @extends {Component}
 */
class Index extends Component {
	/**
	 * Create an instance of Notice change
	 * @param {*} props
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			itemToken: null,
			showMenu: true,
			openModalQuotesByMonthReport: false,
			showToaster: false,
			toasterMessage: null,
			toasterVariant: '',
			openModalQuotesByMonthAndSupplierReport: false,
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		if (!this.props.isLoadingUser) {
			this.props.loadQuotes(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
			this.props.getQuotesCount()
		}
	}

	/**
	 * componentDidUpdate
	 *
	 * @param {*} prevProps
	 * @param {*} prevState
	 * @memberof Index
	 */
	componentDidUpdate(prevProps, prevState) {
		let prevCompanyToken = prevProps.selectedCompany ? prevProps.selectedCompany.token : ''
		if (this.props.selectedCompany && prevCompanyToken !== this.props.selectedCompany.token) {
			this.props.loadQuotes()
			this.props.getQuotesCount()
		} else if (
			prevProps.sortCriteria.by !== this.props.sortCriteria.by ||
			prevProps.sortCriteria.ascending !== this.props.sortCriteria.ascending ||
			prevProps.searchQuery !== this.props.searchQuery ||
			prevProps.page !== this.props.page ||
			prevProps.rowsPerPage !== this.props.rowsPerPage
		) {
			this.props.loadQuotes(
				this.props.searchQuery,
				this.props.sortCriteria.by,
				this.props.sortCriteria.ascending,
				this.props.page,
				this.props.rowsPerPage
			)
		}
	}

	/**
	 * On change sort criteria
	 *
	 * @param {*} sortBy
	 * @param {*} sortAscending
	 * @memberof Index
	 */
	onChangeSortCriteria(sortBy, sortAscending) {
		this.props.changeSortCriteria(sortBy, sortAscending)
	}

	/**
	 * On change search value
	 *
	 * @param {*} searchQuery
	 * @memberof Index
	 */
	onChangeSearchValue(searchQuery) {
		this.props.changeSearchQuery(searchQuery)
	}

	/**
	 * Handle click of options menu component to set item Token in state nd open menu
	 *
	 * @param {*} token
	 * @memberof Index
	 */
	handleClickOptionsMenu(token) {
		this.setState({
			itemToken: token,
		})
	}

	/**
	 * Handle on close optons menu to set void item token in state
	 *
	 * @memberof Index
	 */
	handleCloseOptionsMenu() {
		if (!this.state.openModalQuotesByMonthReport) {
			this.setState(
				{
					itemToken: '',
					showMenu: false,
				},
				() => {
					this.setState({ showMenu: true })
				}
			)
		}
	}

	/**
	 * Open modal for set report by mont
	 *
	 * @memberof Index
	 */
	handleOpenModal() {
		this.setState({
			openModalQuotesByMonthReport: true,
		})
	}

	/**
	 * Open modal for set report by mont and supplier
	 *
	 * @memberof Index
	 */
	handleOpenSupplierModal() {
		this.setState({
			openModalQuotesByMonthAndSupplierReport: true,
		})
	}
	/**
	 * Close modal to report by month
	 *
	 * @memberof Index
	 */
	handleCloseModal() {
		this.setState(
			{
				openModalQuotesByMonthReport: false,
			},
			() => this.handleCloseOptionsMenu()
		)
	}

	/**
	 * Close modal to report by month
	 *
	 * @memberof Index
	 */
	handleCloseSupplierModal() {
		this.setState(
			{
				openModalQuotesByMonthAndSupplierReport: false,
			},
			() => this.handleCloseOptionsMenu()
		)
	}

	/**
	 * On download report quotes in process by supplier
	 *
	 * @memberof Index
	 */
	handleDownloadReportQuoteInProcessSupplier() {
		this.props
			.downloadQuotesInProcessSupplierReport()
			.then(() => {
				this.setState(showSuccessToaster('common.downloadCorrectly'))
			})
			.catch(() => {
				this.setState(showErrorToaster('common.errorToDownload'))
			})
	}

	/**
	 * On download report quotes in process by supplier
	 *
	 * @memberof Index
	 */
	handleDownloadReportByDateRange(startDate, endDate, supplier) {
		this.props
			.downloadReportByDateRange(startDate, endDate, supplier)
			.then(() => {
				this.setState(showSuccessToaster('common.downloadCorrectly'))
				this.handleCloseModal()
			})
			.catch(() => {
				this.setState(showErrorToaster('common.errorToDownload'))
			})
	}
	/**
	 * On render cell item custom
	 * @param {*} dataSource
	 * @param {*} item
	 */
	onRenderCellItem(dataSource, item) {
		if (dataSource === 'days_response') {
			if (item.is_canceled || item.is_declined) {
				return '-'
			} else {
				return (
					<strong
						style={{ fontSize: '100%', padding: '5px', width: '66px', color: 'white' }}
						className={this.getColorResponse(item.days_response)}
					>
						{item.days_response} {<Translate id='quotes.daysQuote' />}
					</strong>
				)
			}
		}
	}

	getColorResponse = (days) => {
		switch (Number(days)) {
			case 0:
			case 1:
			case 2:
			case 3:
				return 'badge badge-success'
			case 4:
			case 5:
				return '#badge badge-warning'
			default:
				return '#badge badge-danger'
		}
	}

	/**
	 * Get the card content
	 *
	 * @memberof Index
	 */
	getCardContent() {
		const { sortCriteria } = this.props
		if (this.props.isLoadingQuotes === true) {
			return <LoadingPage />
		} else if (this.props.quotes === null) {
			return (
				<div className='loader-container'>
					<Typography variant='subtitle1' gutterBottom>
						{' '}
						<Translate id='common.errorToGetInformation' />
					</Typography>
				</div>
			)
		} else {
			return (
				<DataTable
					data={this.props.quotes}
					configuration={TableConfiguration(
						IsCurrentActiveDirectoryUser(this.props.user),
						this.props.selectedCompany
					)}
					sortBy={sortCriteria.by}
					sortAscending={sortCriteria.ascending}
					onChangeSortCriteria={this.onChangeSortCriteria}
					onRowClick={(quote) => {
						this.props.history.push(`/quotes/${quote.token}`)
					}}
					showFilters
					isIndex
					totalRows={this.props.quotesCount}
					page={this.props.page}
					rowsPerPage={this.props.rowsPerPage}
					onChangePage={(newPage, newRowsPerPage) => {
						this.props.changePage(newPage, newRowsPerPage)
					}}
					onRenderCellItem={this.onRenderCellItem}
				/>
			)
		}
	}

	/**
	 * Get quotes counter
	 *
	 * @returns
	 * @memberof Index
	 */
	getQuotesCounterMessage() {
		if (this.props.quotes) {
			let totalQuotes = this.props.quotes.length
			return (
				<div>
					{this.props.translate('common.showing')}&nbsp;
					<span>{totalQuotes}</span>&nbsp;
					{this.props.translate('common.of')}&nbsp;
					<span>{this.props.quotesCount}</span>&nbsp;
					{this.props.translate('common.records')}
				</div>
			)
		}
	}

	/**
	 *Render action button in card quality failure report
	 *
	 * @memberof Index
	 */
	renderAction() {
		var options = []
		if (IsCurrentActiveDirectoryUser(this.props.user)) {
			options.push({
				itemClick: () => this.handleOpenModal(),
				tooltipTranslation: <Translate id='quotes.downloadReportByMonth' />,
				menuItemIcon: <ArchiveDownloadIcon color='secondary' />,
				isLoading: this.props.isLoadingQuote,
			})
		}
		if (!IsCurrentActiveDirectoryUser(this.props.user)) {
			options.push({
				itemClick: () => this.handleDownloadReportQuoteInProcessSupplier(),
				tooltipTranslation: <Translate id='common.downloadReport' />,
				menuItemIcon: <DownloadIcon color='secondary' />,
				isLoading: this.props.isLoadingQuote,
			})
		}
		if (IsCurrentActiveDirectoryUser(this.props.user)) {
			options.push({
				itemClick: () => this.handleOpenSupplierModal(),
				tooltipTranslation: <Translate id='quotes.downloadReportByMonthBySupplier' />,
				menuItemIcon: <DownloadIcon color='secondary' />,
				isLoading: this.props.isLoadingQuote,
			})
		}
		return (
			<OptionsMenu
				itemToken={'item.token'}
				handleClickOptions={this.handleClickOptionsMenu}
				open={this.state.itemToken === 'item.token'}
				handleClickAway={this.handleCloseOptionsMenu}
				options={options}
			/>
		)
	}

	/**
	 * Render
	 *
	 * @returns
	 * @memberof Quotes
	 */
	render() {
		const { classes } = this.props
		return (
			<Card>
				<CardHeader
					avatar={
						<Avatar>
							<QuotesIcon />
						</Avatar>
					}
					action={
						<div className={classes.actionsToolbar}>
							<SearchInput
								className={classes.searchInput}
								onChangeSearchValue={this.onChangeSearchValue}
								value={this.props.searchQuery}
							/>

							{this.renderAction()}
						</div>
					}
					title={
						<Typography variant='button'>
							<Translate id='menu.quotes' />{' '}
						</Typography>
					}
					subheader={this.getQuotesCounterMessage()}
				/>
				<CardContent>{this.getCardContent()}</CardContent>

				{/** Dialog for select month to download report */}
				<DonwloadReportDialog
					title={<Translate id='quotes.downloadReportByMonth' />}
					open={this.state.openModalQuotesByMonthReport}
					onClose={this.handleCloseModal}
					isSaving={this.props.isLoadingQuote}
					onDonwloadItems={this.handleDownloadReportByDateRange}
				/>

				{/** Dialog for select month and supplier to download report */}
				<DonwloadReportDialog
					title={<Translate id='quotes.downloadReportByMonthBySupplier' />}
					open={this.state.openModalQuotesByMonthAndSupplierReport}
					onClose={this.handleCloseSupplierModal}
					isSaving={this.props.isLoadingQuote}
					onDonwloadItems={this.handleDownloadReportByDateRange}
					isSupplierDownloadReport={true}
				/>
				<Toaster
					message={<Translate id={this.state.toasterMessage} />}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</Card>
		)
	}
}

function TableConfiguration(isUserInternal, selectedCompany) {
	let columns = [
		{
			header: '',
			dataSource: 'status_indicator',
		},
		{
			header: <Translate id='common.status' />,
			dataSource: 'actual_operation_description',
			isSortable: true,
		},
		{
			header: <Translate id='common.folio' />,
			dataSource: 'folio',
			isSortable: true,
		},
		{
			header: <Translate id='common.creationDate' />,
			dataSource: 'creation_date',
			isSortable: true,
		},
		{
			header: <Translate id='quotes.developmentEngineer' />,
			dataSource: 'developer_engineer',
			isSortable: true,
		},
		{
			header: <Translate id='quotes.origin' />,
			dataSource: 'origin',
		},
	]

	if (isUserInternal) {
		columns.push({
			header: <Translate id='common.supplier' />,
			dataSource: 'full_supplier',
			isSortable: true,
		})
	}
	//show days response
	if (selectedCompany && selectedCompany.company_code === 'IMB') {
		columns.push({
			header: <Translate id='quotes.daysResponse' />,
			dataSource: 'days_response',
			isSortable: true,
		})
	}

	return { columns }
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	let selectedCompany = state.profile.get('selectedCompany')
	let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
	return {
		isLoadingUser: state.oidc.isLoadingUser,
		user: user,
		selectedCompany: selectedCompany ? selectedCompany.toJS() : null,
		isLoadingQuotes: state.quotes.get('isLoadingQuotes'),
		isLoadingQuote: state.quotes.get('isLoadingQuote'),
		quotes: state.quotes.get('quotes') ? state.quotes.get('quotes').toJS() : null,
		sortCriteria: state.quotes.get('sortCriteria') ? state.quotes.get('sortCriteria').toJS() : null,
		searchQuery: state.quotes.get('searchQuery'),
		page: state.quotes.get('page'),
		rowsPerPage: state.quotes.get('rowsPerPage'),
		quotesCount: state.quotes.get('quotesCount'),
		translate: getTranslate(state.localize),
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadQuotes: (query, orderBy, sortAscending, page, rowsPerPage) => {
			dispatch(loadQuotesFromBackEnd(query, orderBy, sortAscending, page, rowsPerPage))
		},
		changeSortCriteria: (sortBy, sortAscending) => {
			dispatch({
				type: CHANGE_QUOTES_SORT_CRITERIA,
				sortCriteria: {
					by: sortBy,
					ascending: sortAscending,
				},
			})
		},
		changeSearchQuery: (query) => {
			dispatch({
				type: CHANGE_QUOTES_QUERY,
				query: query,
			})
		},
		changePage: (page, rowsPerPage) => {
			dispatch({
				type: CHANGE_QUOTES_PAGINATION,
				page,
				rowsPerPage,
			})
		},
		getQuotesCount: () => {
			dispatch(getQuotesCount())
		},
		downloadQuotesInProcessSupplierReport: () => {
			return dispatch(downloadQuotesInProcessSupplierReport())
		},
		downloadReportByDateRange: (startDate, endDate, supplier) => {
			return dispatch(downloadReportByDateRangeReport(startDate, endDate, supplier))
		},
	}
}

const styles = (theme) => ({
	avatar: {},
	actionsToolbar: {
		display: 'flex',
	},
	searchInput: {
		marginTop: '5px',
	},
	showingUsersCounter: {
		color: theme.palette.secondary.main,
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Index)))
)
